import React, {useMemo} from "react";
// nodejs library that concatenates classes
// reactstrap components

import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  FormFeedback,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
  Navbar,
  NavbarBrand
} from "reactstrap";
import {useHistory} from "react-router-dom";
import { userService } from "services";
import {DangerAlert} from"../components/custom/alerts";
import { useFormHandler } from "hooks";





const ManageUsers = ({...props}) => {
  const history = useHistory();
  const { showNotify, notifyRef } = props;

  const defaultFormValues = useMemo(
    () => ({
      email: "",
      username: "",
      password: "",
      first_name: "",
      last_name: "",
      is_superuser: false,
      is_staff: false,
    }),
    [],
  );

  const validate = (values) => {
    const erros = {};
    if (!values.username?.trim()) erros.username = "Nome de usuário é obrigatório";
    if (!values.email?.trim()) erros.email = "Email é obrigatório";
    if (!values.password?.trim()) erros.password = "Senha é obrigatória";
    if (!values.first_name?.trim()) erros.first_name = "Primeiro nome é obrigatório";
    return erros;
  };

  const form = useFormHandler(defaultFormValues, { validate });

    const submitForm = form.handleSubmit(async (formData) => {
      const payload = {
        ...formData,
        is_superuser: false,
        is_staff: false,
      };

      try {
        await userService.create(payload);
        showNotify(notifyRef, "Cadastro Realizado", "Usuário criado com sucesso.", "success");
        props.refresh(true);
        form.reset(defaultFormValues);
      } catch (error) {
        if (error.response) {
          const data = error.response.data;

          if (data.detail) {
            history.push("/auth/login");
            return;
          }

          const backendErrors = {};
          const fieldMessages = [];
          for (const field of ['username', 'email', 'password', 'first_name', 'last_name']) {
            if (data[field]) {
              backendErrors[field] = Array.isArray(data[field]) ? data[field].join(' ') : data[field];
              fieldMessages.push(Array.isArray(data[field]) ? data[field].join(' ') : data[field]);
            }
          }

          if (Object.keys(backendErrors).length > 0) {
            form.setErrors(backendErrors);
            form.setTouched(
              Object.keys(backendErrors).reduce((acc, k) => ({ ...acc, [k]: true }), {})
            );
          }

          const message = fieldMessages.join('\n') || "Erro inesperado ao criar usuário.";
          showNotify(notifyRef, "Falha no Cadastro", message, "danger");
        } else {
          showNotify(notifyRef, "Falha no Cadastro", "Falha ao conectar com o servidor.", "danger");
        }
      }
    });

  return (
      <>
    <Container>
      <Row className="justify-content-center">
        <Col style={{padding: '0'}}>
          <Card className="bg-secondary border-0">
          <Navbar className="navbar-horizontal navbar-dark bg-default"expand="lg" style={{
                width: '100%',
                height: '50px'
            }}>
                <Container>
                    <NavbarBrand style={{cursor: 'default', userSelect:'none'}}>
                        Criar novo usuário
                    </NavbarBrand>
                    <Button color="danger" size="sm" type="button" onClick={props.close}>
                        Fechar
                    </Button>
                </Container>
            </Navbar>
            <CardBody className="px-lg-5 py-lg-5" >
              <Form role="form" onSubmit={submitForm}>
                <FormGroup>
                  <InputGroup className="input-group-merge input-group-alternative mb-3">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-hat-3" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Usuário *"
                      name="username"
                      type="text"
                      id="username"
                      {...form.register("username")}
                      invalid={form.touched.username && Boolean(form.errors.username)}
                    />
                    {form.touched.username && form.errors.username && (
                      <FormFeedback>{form.errors.username}</FormFeedback>
                    )}
                  </InputGroup>
                </FormGroup>
                <FormGroup>
                  <InputGroup className="input-group-merge input-group-alternative mb-3">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-email-83" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Email *"
                      name="email"
                      type="email"
                      id="email"
                      {...form.register("email")}
                      invalid={form.touched.email && Boolean(form.errors.email)}
                    />
                    {form.touched.email && form.errors.email && (
                      <FormFeedback>{form.errors.email}</FormFeedback>
                    )}
                  </InputGroup>
                </FormGroup>
                <FormGroup style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "10px"
                }}>
                  <InputGroup className="input-group-merge input-group-alternative mb-3" style={{
                    width: "48%",
                    marginRight: "15px"
                  }}>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-single-02"/>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Primeiro Nome *"
                      name="first_name"
                      type="text"
                      id="first_name"
                      {...form.register("first_name")}
                      invalid={form.touched.first_name && Boolean(form.errors.first_name)}
                    />
                    {form.touched.first_name && form.errors.first_name && (
                      <FormFeedback>{form.errors.first_name}</FormFeedback>
                    )}
                  </InputGroup>
                  <InputGroup className="input-group-merge input-group-alternative mb-3" style={{
                    width: "48%"
                  }}>
                    <Input
                      placeholder="Último Nome"
                      name="last_name"
                      type="text"
                      id="last_name"
                      {...form.register("last_name")}
                    />
                  </InputGroup>
                </FormGroup>
                <FormGroup>
                  <InputGroup className="input-group-merge input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-lock-circle-open" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Senha *"
                      name="password"
                      type="password"
                      id="password"
                      {...form.register("password")}
                      invalid={form.touched.password && Boolean(form.errors.password)}
                    />
                    {form.touched.password && form.errors.password && (
                      <FormFeedback>{form.errors.password}</FormFeedback>
                    )}
                  </InputGroup>
                </FormGroup>
                <div style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  {/* <FormControl variant="outlined" required className={classes.formControl}>
                    <InputLabel id="demo-simple-select-outlined-label">Permission</InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      value={selected}
                      onChange={handleChange}
                      label="Permission"
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {permission.map((data, index) => (<MenuItem key={`menuitem-${index}`} value={data.idPermission}>{data.name}</MenuItem>))}
                    </Select>
                  </FormControl> */}
                </div>
                <div className="text-center">
                  <Button className="mt-4" color="primary" type="submit">
                    Criar Conta
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <DangerAlert/>
    </Container>
  </>
  )
}

export default ManageUsers
